import React, { useState, useEffect } from 'react';
import { ChevronRight, Zap, Smartphone, DollarSign, QrCode, Settings, Rocket, Code, CheckCircle2, Clock, Lock, Users, TrendingUp } from 'lucide-react';
import Kontakt from './pages/Kontakt';
import Impressum from './pages/Impressum';
import CookieBanner from './CookieBanner';

export default function ITSeevetal() {
  const [currentPage, setCurrentPage] = useState('home');
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const products = [
    {
      id: 'offera',
      name: 'Offera',
      tagline: 'Angebote. Professionell. Einfach.',
      image: '📋',
      features: [
        { icon: '🎨', text: 'Design Anpassung' },
        { icon: '💾', text: 'Kundenverwaltung' },
        { icon: '📥', text: 'PDF Export' },
        { icon: '🏢', text: 'Firmendaten' },
        { icon: '⚡', text: 'Blitzschnell' },
        { icon: '📱', text: 'Mobile optimiert' }
      ],
      url: 'https://angebotgenerator.com',
      headerColor: '#1a472a',
      headerGradient: 'from-green-900 to-green-800',
      titleColor: '#d4af37',
      buttonColor: '#d4af37',
      buttonBg: 'bg-yellow-500 hover:bg-yellow-600'
    },
    {
      id: 'faktura',
      name: 'Faktura',
      tagline: 'Rechnungen. Rechtssicher. Einfach.',
      image: '💳',
      features: [
        { icon: '📄', text: 'PDF-Export druckbereit' },
        { icon: '🇩🇪', text: 'Rechtssicher' },
        { icon: '🎨', text: '3 Vorlagen' },
        { icon: '📊', text: 'Rechnungsverlauf' },
        { icon: '📱', text: 'Mobile optimiert' }
      ],
      url: 'https://rechnungsgenerator.com/',
      headerColor: '#c8440a',
      headerGradient: 'from-gray-950 to-gray-700',
      titleColor: '#c8440a',
      buttonColor: '#c8440a',
      buttonBg: 'bg-orange-600 hover:bg-orange-700'
    },
    {
      id: 'qrmake',
      name: 'qrmake',
      tagline: 'QR-Codes in Sekunden.',
      image: '📱',
      features: [
        { icon: '🆓', text: 'Kostenlos & unbegrenzt' },
        { icon: '⚡', text: 'QR-Codes in Sekunden' },
        { icon: '🔗', text: 'Dynamische Codes (Pro)' },
        { icon: '🎨', text: 'Logo & Farben (Pro)' },
        { icon: '📤', text: 'PNG/SVG/PDF/EPS (Pro)' },
        { icon: '📱', text: 'Mobile optimiert' }
      ],
      url: 'https://www.qrmake.de/',
      headerColor: '#000',
      headerGradient: 'from-gray-900 via-purple-900 to-gray-900',
      titleColor: '#00d4ff',
      buttonColor: '#00d4ff',
      buttonBg: 'bg-cyan-400 hover:bg-cyan-500 text-black font-bold'
    },
    {
      id: 'kalkulpro',
      name: 'KalkuPro',
      tagline: 'Preise kalkulieren. Gewinn verstehen.',
      image: '📊',
      features: [
        { icon: '🏭', text: 'Lieferanten-Verwaltung' },
        { icon: '📦', text: 'Artikel & Preise' },
        { icon: '📊', text: 'Automatische Kalkulation' },
        { icon: '⚠️', text: 'Mindestmarge-Warnung' },
        { icon: '🎨', text: 'Eigenes Branding (Pro)' },
        { icon: '📱', text: 'Mobile optimiert' }
      ],
      url: 'https://www.kalku-pro.de',
      headerColor: '#6d28d9',
      headerGradient: 'from-violet-700 via-indigo-600 to-blue-500',
      titleColor: '#e9d5ff',
      buttonColor: '#6d28d9',
      buttonBg: 'bg-violet-600 hover:bg-violet-700'
    }
  ];

  const roadmapItems = [
    {
      title: 'Ticketsystem',
      description: 'Zentralisierte Ticketverwaltung für Anfragen und Support. Integration mit E-Mail und automatische Benachrichtigungen.',
      status: 'planned',
      quarter: 'Q3 2026'
    },
    {
      title: 'API-Verknüpfung',
      description: 'Verbinde Offera mit Faktura mit nur einem Klick. Automatischer Datentransfer zwischen Angebot und Rechnung.',
      status: 'in-progress',
      quarter: 'Q3 2026'
    },
    {
      title: 'Dokumentations-Plattform',
      description: 'Zentrale Dokumentenverwaltung für dein Team. Organisiere alles an einem Ort – ähnlich wie Confluence oder IT-Glue, aber speziell für dein Ökosystem.',
      status: 'in-progress',
      quarter: 'Q4 2026'
    }
  ];

  const contactOptions = [
    {
      icon: '💬',
      title: 'Live Chat',
      description: 'Sofortige Antworten zu schnellen Fragen',
      detail: 'Kommt bald',
      action: 'Kommt bald',
      link: '#'
    },
    {
      icon: '📧',
      title: 'E-Mail Support',
      description: 'Detaillierte Anfragen mit Screenshots',
      detail: 'info@it-seevetal.de',
      action: 'E-Mail schreiben',
      link: 'mailto:info@it-seevetal.de'
    },
    {
      icon: '☎️',
      title: 'Telefon',
      description: 'Für dringende Fälle oder komplexe Themen',
      detail: '+49 4105 6925100',
      action: 'Anrufen',
      link: 'tel:+494105692510'
    },
    {
      icon: '🎫',
      title: 'Ticketsystem',
      description: 'Für Projekte und längerfristige Anfragen',
      detail: 'Kommt bald',
      action: 'Kommt bald',
      link: '#'
    }
  ];

  // Routing
  if (currentPage === 'kontakt') return <Kontakt onBack={() => setCurrentPage('home')} />;
  if (currentPage === 'impressum') return <Impressum onBack={() => setCurrentPage('home')} />;

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className={`fixed w-full top-0 z-50 transition-all ${isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}>
        <nav className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
          <button onClick={() => setCurrentPage('home')} className="flex items-center gap-2 cursor-pointer">
            <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-lg flex items-center justify-center">
              <Zap className="w-6 h-6 text-white" />
            </div>
            <div>
              <p className="font-bold text-gray-900">IT-Seevetal</p>
              <p className="text-xs text-gray-500">Schnell. Klar. Digital.</p>
            </div>
          </button>
          <div className="hidden md:flex gap-8 items-center text-sm">
            <a href="#ecosystem" className="text-gray-700 hover:text-blue-600 transition">Ökosystem</a>
            <a href="#custom" className="text-gray-700 hover:text-blue-600 transition">Custom Apps</a>
            <a href="#roadmap" className="text-gray-700 hover:text-blue-600 transition">Roadmap</a>
            <button onClick={() => setCurrentPage('kontakt')} className="px-4 py-2 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-lg hover:shadow-lg transition cursor-pointer">Kontakt</button>
          </div>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="pt-32 pb-24 px-6 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-6xl mx-auto text-center">
          <div className="inline-block mb-6 px-4 py-2 bg-blue-50 rounded-full border border-blue-200">
            <p className="text-sm font-medium text-blue-700">🚀 Modernes IT-Ökosystem für Freelancer & Selbstständige</p>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Intelligente Apps.
            <br />
            <span className="bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">Deine beste Zeit zurück.</span>
          </h1>
          
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-12">
            Moderne Webapps, die deinen Alltag vereinfachen. Damit du dich auf deine Kernarbeit konzentrierst – und wir kümmern uns um den Rest.
          </p>

          <div className="flex gap-4 justify-center flex-wrap">
            <a href="#ecosystem" className="px-8 py-3 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-lg hover:shadow-xl transition font-medium">
              Entdecke unser Ökosystem
            </a>
            <a href="#custom" className="px-8 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition font-medium">
              Individuelle Lösungen
            </a>
          </div>
        </div>
      </section>

      {/* Ecosystem Products */}
      <section id="ecosystem" className="py-24 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Dein digitales Ökosystem</h2>
            <p className="text-lg text-gray-600">Drei mächtige Apps, perfekt aufeinander abgestimmt</p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {products.map((product) => (
              <a
                key={product.id}
                href={product.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex flex-col h-full"
              >
                <div className="h-full bg-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:border-gray-300 flex flex-col">
                  {/* Image Header mit Custom CI */}
                  <div 
                    className={`bg-gradient-to-br ${product.headerGradient} h-40 flex flex-col items-center justify-center px-4`}
                    style={{ backgroundImage: product.id === 'qrmake' ? 'linear-gradient(135deg, #0f0c29, #302b63, #24243e)' : undefined }}
                  >
                    <h3 
                      className="font-black text-center mb-3"
                      style={{ 
                        fontFamily: product.id === 'qrmake' ? 'system-ui, sans-serif' : 'Georgia, serif',
                        fontSize: '36px',
                        fontWeight: product.id === 'qrmake' ? 700 : 900,
                        color: product.titleColor,
                        letterSpacing: product.id === 'qrmake' ? '0px' : '-1px'
                      }}
                    >
                      {product.name}
                    </h3>
                    <p 
                      className="text-gray-400 text-center"
                      style={{ 
                        fontSize: '10px',
                        fontWeight: 600,
                        textTransform: product.id === 'qrmake' ? 'none' : 'uppercase'
                      }}
                    >
                      {product.tagline}
                    </p>
                  </div>

                  {/* Content */}
                  <div className="p-6 flex-1 flex flex-col">
                    {/* Features */}
                    <div className="space-y-2 mb-6 flex-1">
                      {product.features.map((feature, idx) => (
                        <div key={idx} className="flex items-center gap-2">
                          <span className="text-lg">{feature.icon}</span>
                          <span className="text-sm text-gray-700">{feature.text}</span>
                        </div>
                      ))}
                    </div>

                    {/* CTA - Fixed at bottom */}
                    <div className={`flex items-center gap-2 font-medium group-hover:gap-3 transition-all ${product.buttonBg} px-4 py-2 rounded text-center justify-center cursor-pointer`} style={{ color: product.id === 'qrmake' ? '#000000' : '#fff' }}>
                      App öffnen <ChevronRight className="w-4 h-4" />
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>

          {/* Integration Preview */}
          <div className="mt-20 p-8 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl border border-blue-200">
            <div className="flex items-start gap-4">
              <Zap className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Nahtlose Integration (Coming Soon)</h3>
                <p className="text-gray-700">Verbinde deine Apps mit einem Klick. Angebote werden automatisch zu Rechnungen, Daten fließen perfekt ineinander – ohne manuelles Copy-Paste.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Custom Development */}
      <section id="custom" className="py-24 px-6 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Left: Features */}
            <div>
              <div className="inline-block mb-4 px-3 py-1 bg-orange-100 rounded-full border border-orange-300">
                <p className="text-sm font-medium text-orange-700">Maßgeschneidert</p>
              </div>
              
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Individuelle Webapps
                <br />
                <span className="text-transparent bg-gradient-to-r from-orange-600 to-red-500 bg-clip-text">für deine Anforderungen</span>
              </h2>

              <p className="text-lg text-gray-600 mb-8">
                Unsere Core-Apps sind großartig. Aber manchmal brauchst du etwas Spezielles. Wir bauen dir eine Custom Webapp – komplett auf deine Bedürfnisse zugeschnitten, mit deinem Design, deiner Logik, deinem Workflow.
              </p>

              <ul className="space-y-4 mb-8">
                {[
                  { icon: Code, text: 'Moderne Technologie & sauberer Code' },
                  { icon: Smartphone, text: 'Responsive Design für alle Geräte' },
                  { icon: TrendingUp, text: 'Skalierbar und zukunftssicher' },
                  { icon: Users, text: 'Dein Team im Mittelpunkt' }
                ].map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <item.icon className="w-5 h-5 text-orange-600 flex-shrink-0 mt-1" />
                    <span className="text-gray-700 font-medium">{item.text}</span>
                  </li>
                ))}
              </ul>

              <button onClick={() => setCurrentPage('kontakt')} className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-orange-600 to-red-500 text-white rounded-lg hover:shadow-xl transition font-medium cursor-pointer">
                Anfrage stellen <ChevronRight className="w-4 h-4" />
              </button>
            </div>

            {/* Right: Examples */}
            <div className="space-y-4">
              {[
                {
                  title: 'Projekt-Management Dashboard',
                  examples: 'Kanban-Boards, Zeiterfassung, Reporting'
                },
                {
                  title: 'CRM-Lösung',
                  examples: 'Kundenmanagement, Kontakt-Historie, Automation'
                },
                {
                  title: 'Content Management System',
                  examples: 'Blog, Portfolio, SEO-Optimierung'
                },
                {
                  title: 'Analytics & Reporting',
                  examples: 'Dashboard, Metriken, Daten-Visualisierung'
                },
                {
                  title: 'Team-Collaboration Tools',
                  examples: 'Messaging, File-Sharing, Integrationen'
                }
              ].map((example, idx) => (
                <div key={idx} className="p-4 bg-white border border-gray-200 rounded-xl hover:shadow-md transition">
                  <p className="font-bold text-gray-900">{example.title}</p>
                  <p className="text-sm text-gray-600 mt-1">{example.examples}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Roadmap */}
      <section id="roadmap" className="py-24 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Demnächst verfügbar</h2>
            <p className="text-lg text-gray-600">Schau, an was wir gerade arbeiten</p>
          </div>

          <div className="space-y-6">
            {roadmapItems.map((item, idx) => (
              <div key={idx} className="flex gap-6">
                {/* Timeline */}
                <div className="flex flex-col items-center">
                  <div className={`w-4 h-4 rounded-full ${item.status === 'in-progress' ? 'bg-blue-600' : 'bg-gray-300'}`} />
                  {idx < roadmapItems.length - 1 && <div className="w-1 h-24 bg-gray-200 mt-2" />}
                </div>

                {/* Content */}
                <div className="pb-6 flex-1">
                  <div className="flex items-start justify-between mb-2">
                    <h3 className="text-xl font-bold text-gray-900">{item.title}</h3>
                    <span className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
                      item.status === 'in-progress'
                        ? 'bg-blue-50 text-blue-700'
                        : 'bg-gray-50 text-gray-700'
                    }`}>
                      {item.status === 'in-progress' ? '⚡ In Arbeit' : '🗓️ Geplant'}
                    </span>
                  </div>
                  <p className="text-gray-600 mb-2">{item.description}</p>
                  <p className="text-sm text-gray-500">{item.quarter}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-24 px-6 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Warum IT-Seevetal?</h2>
            <p className="text-lg text-gray-600">Wir bauen nicht nur Software – wir bauen Werkzeuge für deinen Erfolg</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: Rocket,
                title: 'Super schnell',
                description: 'Optimierte Performance und blitzschnelle Ladezeiten. Deine Produktivität wartet nicht.'
              },
              {
                icon: Lock,
                title: 'Sicher & Datenschutz',
                description: 'Deutsche Server, GDPR-konform, SSL-verschlüsselt. Deine Daten in sicheren Händen.'
              },
              {
                icon: Users,
                title: 'Support, der hilft',
                description: 'Direkter Kontakt, schnelle Antworten. Nicht nur ein Bot – echte Menschen helfen dir.'
              }
            ].map((item, idx) => (
              <div key={idx} className="p-8 bg-white border border-gray-200 rounded-2xl text-center hover:shadow-lg transition">
                <item.icon className="w-12 h-12 text-blue-600 mx-auto mb-4" />
                <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-r from-blue-600 to-cyan-500">
        <div className="max-w-3xl mx-auto text-center text-white">
          <h2 className="text-4xl font-bold mb-4">Bereit, Zeit zu sparen?</h2>
          <p className="text-xl text-blue-100 mb-8">
            Starte noch heute mit unseren Apps oder lass uns deine individuelle Lösung bauen.
          </p>
          <button onClick={() => setCurrentPage('kontakt')} className="inline-flex items-center gap-2 px-8 py-4 bg-white text-blue-600 rounded-lg hover:shadow-xl transition font-bold text-lg cursor-pointer">
            Jetzt starten <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-24 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Kontakt & Support</h2>
            <p className="text-lg text-gray-600">Wir sind hier, um zu helfen</p>
          </div>

          <div className="grid md:grid-cols-4 gap-4 mb-12">
            {contactOptions.map((item, idx) => (
              <div key={idx} className="p-6 bg-gray-50 rounded-xl text-center">
                <p className="text-4xl mb-3">{item.icon}</p>
                <h3 className="font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-sm text-gray-600 mb-3">{item.description}</p>
                <p className="text-sm font-mono text-gray-700 bg-white px-2 py-1 rounded mb-3">{item.detail}</p>
                {item.link !== '#' ? (
                  <a href={item.link} className="text-sm text-blue-600 hover:text-blue-700 font-medium">
                    {item.action} →
                  </a>
                ) : (
                  <p className="text-sm text-gray-500 italic">{item.action}</p>
                )}
              </div>
            ))}
          </div>

          <form action="https://formspree.io/f/xdavpgon" method="POST" className="bg-gray-50 p-8 rounded-2xl border border-gray-200">
            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <input type="text" name="name" placeholder="Dein Name" className="px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500" required />
              <input type="email" name="email" placeholder="Deine E-Mail" className="px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500" required />
            </div>
            <textarea name="message" placeholder="Deine Nachricht" rows="5" className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 mb-6" required />
            <button type="submit" className="w-full px-6 py-3 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-lg hover:shadow-xl transition font-bold">
              Nachricht senden
            </button>
          </form>
        </div>
      </section>

      {/* Cookie Banner */}
      <CookieBanner onNavigateToImpressum={() => setCurrentPage('impressum')} />

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-16 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Main Footer */}
          <div className="grid md:grid-cols-4 gap-8 mb-12 pb-12 border-b border-gray-800">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-lg flex items-center justify-center">
                  <Zap className="w-5 h-5 text-white" />
                </div>
                <span className="font-bold text-white">IT-Seevetal</span>
              </div>
              <p className="text-sm">Schnell. Klar. Digital.</p>
            </div>

            <div>
              <h4 className="text-white font-bold mb-4">Produkte</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="https://angebotgenerator.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">Offera</a></li>
                <li><a href="https://rechnungsgenerator.com/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">Faktura</a></li>
                <li><a href="https://www.qrmake.de/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">QRmake</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-bold mb-4">Company</h4>
              <ul className="space-y-2 text-sm">
                <li><button className="hover:text-white transition cursor-pointer text-left">Blog</button></li>
                <li><button className="hover:text-white transition cursor-pointer text-left">Dokumentation</button></li>
                <li><button onClick={() => setCurrentPage('kontakt')} className="hover:text-white transition cursor-pointer text-left">Kontakt</button></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-bold mb-4">Rechtliches</h4>
              <ul className="space-y-2 text-sm">
                <li><button onClick={() => setCurrentPage('impressum')} className="hover:text-white transition cursor-pointer text-left">Impressum</button></li>
                <li><button onClick={() => setCurrentPage('impressum')} className="hover:text-white transition cursor-pointer text-left">Datenschutz</button></li>
                <li><button className="hover:text-white transition cursor-pointer text-left">AGB</button></li>
              </ul>
            </div>
          </div>

          {/* Bottom Footer */}
          <div className="flex flex-col md:flex-row justify-between items-center text-sm">
            <p>© 2026 IT-Seevetal. Alle Rechte vorbehalten.</p>
            <div className="flex gap-6 mt-4 md:mt-0">
              <button className="hover:text-white transition cursor-pointer">Twitter</button>
              <button className="hover:text-white transition cursor-pointer">LinkedIn</button>
              <a href="https://github.com/IT-Seevetal" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">GitHub</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}